/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S16_HeadingInputs */

const tr_kullanim_s16_heading = /** @type {(inputs: Kullanim_S16_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`16. Mücbir Sebepler`)
};

const en_kullanim_s16_heading = /** @type {(inputs: Kullanim_S16_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`16. Force majeure`)
};

const de_kullanim_s16_heading = /** @type {(inputs: Kullanim_S16_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`16. Höhere Gewalt`)
};

const ru_kullanim_s16_heading = /** @type {(inputs: Kullanim_S16_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`16. Форс-мажор`)
};

/**
* | output |
* | --- |
* | "16. Force majeure" |
*
* @param {Kullanim_S16_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s16_heading = /** @type {((inputs?: Kullanim_S16_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S16_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s16_heading(inputs)
	if (locale === "de") return de_kullanim_s16_heading(inputs)
	if (locale === "ru") return ru_kullanim_s16_heading(inputs)
	return tr_kullanim_s16_heading(inputs)
});